<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `transaction/course-schedule/${inputs.id}`
            : `transaction/course-schedule`
        "
      >
        <!-- Course ID -->
        <div class="form-group row align-items-center">
          <label for="inputs_course_id" class="col-sm-3 mb-0"> Class </label>
          <app-input
            id="inputs_course_id"
            class="col-sm-9"
            type="advance-search-select"
            :loaded-per-time="3"
            v-model="input_course_id"
            @input="setCourseIdValue"
            fetch-url="transaction/course"
            placeholder="Class"
            list-value-field="course_name"
            :required="true"
          />
        </div>

        <!-- Product -->
        <div class="form-group row align-items-center">
          <label for="inputs_product_id" class="col-sm-3 mb-0"> Product </label>
          <app-input
            id="inputs_product_id"
            class="col-sm-9"
            type="text"
            v-model="inputs.product_id"
            :placeholder="'Prdouct'"
            :disabled="true"
          />
        </div>

        <!-- Day ID -->
        <div class="form-group row align-items-center">
          <label for="inputs_day_id" class="col-sm-3 mb-0"> Day </label>
          <app-input
            id="inputs_day_id"
            class="col-sm-9"
            type="search-select"
            :list="dayIdLists"
            v-model="inputs.day_id"
            :placeholder="'Day'"
            :required="true"
          />
        </div>

        <!-- Time Start -->
        <div class="form-group row align-items-center">
          <label for="inputs_time_start" class="col-sm-3 mb-0">
            Time Start
          </label>
          <app-input
            id="inputs_time_start"
            class="col-sm-9"
            type="time"
            v-model="inputs.time_start"
            :placeholder="'Time Start'"
            :use-default-time-picker="false"
            :required="true"
          />
        </div>

        <!-- Time End -->
        <div class="form-group row align-items-center">
          <label for="inputs_time_end" class="col-sm-3 mb-0"> Time End </label>
          <app-input
            id="inputs_time_end"
            class="col-sm-9"
            type="time"
            v-model="inputs.time_end"
            :placeholder="'Time End'"
            :required="true"
          />
        </div>

        <!-- Course Group ID -->
        <div class="form-group row align-items-center">
          <label for="inputs_course_group_id" class="col-sm-3 mb-0">
            Class Group
          </label>

          <app-input
            type="advance-search-select"
            :loaded-per-time="10"
            class="col-sm-9"
            v-model="input_course_group_id"
            @input="setCourseGroupId"
            :fetch-url="`${COURSE_GROUP_ENDPOINT}?per_page=${perPage}`"
            :placeholder="$t('course_group')"
            list-value-field="course_group_name"
            required
          />

          <!-- <app-input
						id="inputs_course_group_id"
						class="col-sm-9"
						type="search-select"
						:list="courseGroupIdLists"
						v-model="inputs.course_group_id"
						:placeholder="'Class Group'"
						:required="true"
					/> -->
        </div>

        <!-- Note -->
        <div class="form-group row align-items-center">
          <label for="inputs_note" class="col-sm-3 mb-0"> Note </label>
          <app-input
            id="inputs_note"
            class="col-sm-9"
            type="textarea"
            v-model="inputs.note"
            :placeholder="'Note'"
            :required="true"
          />
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import { COURSE_GROUP } from "../../../../Config/ApiUrl";

export default {
  name: "ModalForm",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    formId: String,
    value: {
      type: Object,
      default: () => {
        return {
          id: undefined,
        };
      },
    },
  },
  data() {
    return {
      perPage: 10,
      COURSE_GROUP_ENDPOINT: COURSE_GROUP,
      preloader: false,
      inputs: {
        course_id: 0,
        product_id: "",
        day_id: 0,
        time_start: "",
        time_end: "",
        course_group_id: 0,
      },
      input_course_group_id: this.value
        ? this.value
          ? {
              id: this.value.course_group_id || 0,
              course_group_name: this.value.course_group_name || "",
            }
          : {
              id: this.value?.id || 0,
              course_group_name: this.value?.course_group_name || "",
            }
        : {
            id: this.value.course_group_id || 0,
            course_group_name: this.value.course_group_name || "",
          },
      input_course_id: this.value
        ? this.value.course
          ? {
              id: this.value.course.id || 0,
              course_name: this.value.course.course_name || "",
              is_active: this.value.course.is_active,
            }
          : {
              id: this.value.course?.id || 0,
              course_name: this.value.course?.course_name || "",
              is_active: this.value.course?.is_active,
            }
        : {
            id: this.value.course.id || 0,
            course_name: this.value.course.course_name || "",
            is_active: this.value.course.is_active,
          },
      dayIdLists: [],
      // courseGroupIdLists: [],
      modalId: this.formId,
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }

    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        if (this.selectedUrl) {
          this.modalTitle = this.$t("edit");
          this.preloader = true;
        }

        let [dayResponse] = await Promise.all([
          axios.get("/master/day?per_page=1000"),
          
        ]);

        dayResponse.data.data.map((item) => {
          this.dayIdLists.push({
            id: item.id,
            value: item.day_name,
          });
        });

        // courseGroupResponse.data.data.map((item) => {
        //   this.courseGroupIdLists.push({
        //     id: item.id,
        //     value: item.course_group_name,
        //   });
        // });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    submit() {
      this.inputs.is_active = this.inputs.is_active ? 1 : 0;
      this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.input_course_id = response.data.course_id;
      this.input_course_group_id = response.data.course_group_id;
      this.inputs.course_id = response.data.course_id.id;
      this.inputs.day_id = response.data.day_id.id;
      this.inputs.time_start = response.data.time_start.slice(0, -3);
      this.inputs.time_end = response.data.time_end.slice(0, -3);
      this.inputs.course_group_id = response.data.course_group_id.id;
      this.preloader = false;
    },

    setCourseIdValue(data) {
      this.inputs.course_id = data.id;
      if (data && data.hasOwnProperty("id")) {
        this.inputs.course_id = data.id;
        this.inputs.product_id = data.product.name;
      }
    },

    setCourseGroupId(data) {
      this.inputs.course_group_id = data.id;
      if (data && data.hasOwnProperty("id")) {
        this.inputs.course_group_id = data.id;
      }
    },
  },
};
</script>
